import { post } from './post';
import { root, id } from './social';

export const social = {
  ...root,
  id,
  post,
};
